import { ReactComponent as CrossIcon } from 'assets/icon/x-circle.svg';
import { useAppDispatch, useAppSelector } from 'hooks/useAppDispatchSelector';
import { setModal } from 'store/features/modelSlice';
import { initModal, modalEnum } from 'helpers/utils';
import { useContext, useEffect } from 'react';
import { AppContext } from 'context/app-context';
import {
  IAlertTemplateItem,
  getAlertsTemplates,
  removeAlertTemplate,
  setAlertsTemplates,
  setSelectAlertTemplate,
} from 'store/features/alertsSlice';
import TrashIcon from 'assets/icon/trash';
import { useTranslation } from 'react-i18next';

const AlertTemplates = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { alertsTemplates } = useAppSelector(state => state.alerts);
  const {
    modal: {
      content: { callBackFun },
    },
  } = useAppSelector(state => state.modal);
  const { setLoader } = useContext(AppContext);
  const fetchAlertTemplates = async () => {
    try {
      setLoader(true);
      await dispatch(getAlertsTemplates());
      setLoader(false);
    } catch (e) {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchAlertTemplates();
  }, []);
  const handleSetSelectedAlert = (data: IAlertTemplateItem) => {
    try {
      setLoader(true);
      dispatch(setSelectAlertTemplate(data));
      dispatch(
        setModal({
          type: modalEnum.ADD_EDIT_PROGRAMMED_ALERTS,
          content: { title: 'Create Alert', callBackFun: callBackFun ? callBackFun : () => {} },
        }),
      );
      setLoader(false);
    } catch (error) {}
  };
  const handleRemoveAlertTemplate = async (data: IAlertTemplateItem) => {
    try {
      setLoader(true);
      await dispatch(removeAlertTemplate({ template_id: data?.id || data?._id || '' }));
      await dispatch(setAlertsTemplates(alertsTemplates?.filter(item => item?._id !== data._id)));
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <div className="flex flex-col max-w-[500px] w-[500px] max-h-[calc(100vh-250px)] gap-y-4 overflow-hidden">
      <div className="flex items-center w-full">
        <div className="flex items-center flex-1">
          <label className="pl-2 text-xl font-semibold text-black2">
            {t('alerts.alert_template_btn')}
          </label>
        </div>
        <div
          className="flex items-center justify-center cursor-pointer"
          onClick={() => dispatch(setModal(initModal))}
        >
          <CrossIcon height={32} width={32} />
        </div>
      </div>
      <div className="flex flex-wrap w-full overflow-y-auto flex-1 gap-y-1">
        {alertsTemplates.length ? (
          [...alertsTemplates].map((data, index) => (
            <div
              className="flex items-center w-full border-b-1 px-2 py-3 hover:bg-grey4 cursor-pointer"
              onClick={() => handleSetSelectedAlert(data)}
              key={data?._id}
            >
              <label className="font-medium text-base text-black2 w-full cursor-pointer flex-1">
                {data?.title}
              </label>
              <div
                className="flex items-center justify-center cursor-pointer"
                onClick={e => {
                  e.stopPropagation();
                  handleRemoveAlertTemplate(data);
                }}
              >
                <TrashIcon color="red" height={24} width={24} />
              </div>
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center bg-grey4 rounded-4 p-4 w-full mt-4">
            <label className="flex items-center justify-center w-full text-center font-medium">
              {t('alerts.noAlertTemplateCreated')}
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertTemplates;
